const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardsMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 9.45752H14.25",
    stroke: "#4A4A68",
    style: {
      stroke: "#4A4A68",
      stroke: "color(display-p3 0.2902 0.2902 0.4078)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 7.7101V13.0726C14.2275 15.2101 13.6425 15.7501 11.415 15.7501H4.33502C2.07002 15.7501 1.5 15.1876 1.5 12.9526V7.7101C1.5 5.6851 1.9725 5.0326 3.75 4.9276C3.93 4.9201 4.12502 4.9126 4.33502 4.9126H11.415C13.68 4.9126 14.25 5.4751 14.25 7.7101Z",
    stroke: "#4A4A68",
    style: {
      stroke: "#4A4A68",
      stroke: "color(display-p3 0.2902 0.2902 0.4078)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 5.0475V10.29C16.5 12.315 16.0275 12.9675 14.25 13.0725V7.71C14.25 5.475 13.68 4.9125 11.415 4.9125H4.33502C4.12502 4.9125 3.93 4.92 3.75 4.9275C3.7725 2.79 4.35752 2.25 6.58502 2.25H13.665C15.93 2.25 16.5 2.8125 16.5 5.0475Z",
    stroke: "#4A4A68",
    style: {
      stroke: "#4A4A68",
      stroke: "color(display-p3 0.2902 0.2902 0.4078)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.9375 13.3574H5.22748",
    stroke: "#4A4A68",
    style: {
      stroke: "#4A4A68",
      stroke: "color(display-p3 0.2902 0.2902 0.4078)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.83252 13.3574H9.41252",
    stroke: "#4A4A68",
    style: {
      stroke: "#4A4A68",
      stroke: "color(display-p3 0.2902 0.2902 0.4078)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardsMobile);
export default __webpack_public_path__ + "static/media/cards-mobile.180b93dc556e3aa007977c8f27a4fbc8.svg";
export { ForwardRef as ReactComponent };